import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "App-Startup-Users" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_space = _resolveComponent("el-space")!
  const _directive_blur = _resolveDirective("blur")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_space, { size: -10 }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_ctx.business.founder], (user) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `user-${user._id}`
          }, [
            _createVNode(_component_el_avatar, {
              size: 40,
              src: user.avatar
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$filters.initials(user)), 1)
                ])), [
                  [_directive_blur, user]
                ])
              ]),
              _: 2
            }, 1032, ["src"])
          ]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}